import { render } from "./CompanyOverview.vue?vue&type=template&id=b6ed7728"
import script from "./CompanyOverview.vue?vue&type=script&lang=js"
export * from "./CompanyOverview.vue?vue&type=script&lang=js"

import "./CompanyOverview.vue?vue&type=style&index=0&id=b6ed7728&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__